import React, { useEffect, useState } from "react";

import styles from "./textarea-and-chars-counter.module.scss";
import { useI18N } from "@src/language/language-context";

interface TextareaAndCharsCounterTypes {
  initialValue: string;
  callback: (value: string) => void;
}

const cssClassName = "textarea-and-chars-counter";

export const TextareaAndCharsCounter = ({
  initialValue = "",
  callback,
}: TextareaAndCharsCounterTypes) => {
  const i18n = useI18N();
  const [textareaValue, setTextareaValue] = useState(initialValue || "");
  const [charsCount, setCharsCount] = useState(0);

  const texts = {
    textAreaLabel: i18n("modules.saveBlueprintModal.textAreaLabel"),
    textAreaPlaceholder: i18n("modules.saveBlueprintModal.textAreaPlaceholder"),
  };

  const maxCountTextareaLimit = 260;

  const setTextareaValueAndCharsCount = (
    textareaValue: string | null = "",
    limit = maxCountTextareaLimit,
  ) => {
    const value = (textareaValue || "").substring(0, limit);
    setTextareaValue(value);
    setCharsCount(value.length);
  };

  const textareaOnChange = (e) => {
    setTextareaValueAndCharsCount(e.target.value);
    callback(e.target.value);
  };

  useEffect(() => {
    setTextareaValueAndCharsCount(initialValue);
  }, [initialValue]);

  return (
    <div className={styles[`${cssClassName}__input-wrapper`]}>
      <div className={styles[`${cssClassName}__attribute-name`]}>
        {texts.textAreaLabel}
      </div>
      <textarea
        value={textareaValue}
        onChange={textareaOnChange}
        maxLength={maxCountTextareaLimit}
        className={styles[`${cssClassName}__textarea`]}
        placeholder={texts.textAreaPlaceholder}
      />
      <p className={styles[`${cssClassName}__chars-counter`]}>
        {charsCount}/{maxCountTextareaLimit}
      </p>
    </div>
  );
};
